export default {
  empty: {
    notInitialized: {
      text: {
        notes:
          'Empty title when no decks exists because the screen is not yet initialized',
        message: 'The screen is not yet initialized',
      },
      action: {
        notes: 'Button title for initializing a screen',
        message: 'Initialize',
      },
      actionMetric: {
        notes:
          'Menu item for initializing a screen with metric measurement system',
        message: 'Initialize (Metric)',
      },
      actionUs: {
        notes:
          'Menu item for initializing a screen with US Customary measurement system',
        message: 'Initialize (US Customary)',
      },
    },
  },
};
